import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "SideMenu" })
export default class SideMenu extends Vue {
    public localizer: any = Localizer;
    public selectedSection: string = null;

    get userContext() {
        return this.$store.getters["accountUserStore/userContext"];
    }

    get sections(): any {
        return this.$store.getters["myFileSharingStore/sections"];
    }

    get markets(): any {
        return this.$store.getters["myFileSharingStore/markets"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Watch("$route") onRouteChanged(value: any, oldValue: any) {
        this.selectedSection = this.$route.params.sectionName;
    }

    public async created() {
        await Promise.all([this.$store.dispatch("myFileSharingStore/getSections"), this.$store.dispatch("myFileSharingStore/getMarkets")]);

        this.selectedSection = this.$route.params.sectionName;
    }

    public goToDetail(name: string, category: any) {
        if (category) {
            this.$router.push({ name: 'SectionDetail', params: { sectionName: name }, query: { category: category } }).catch(() => { });
        } else {
            this.$router.push({ name: 'SectionDetail', params: { sectionName: name } }).catch(() => { });
        }
    }

    public goToSectionProductImages() {
        this.$router.push({ name: 'SectionProductImages' }).catch(() => { });
    }

    public goToCustomSection(sectionName: string) {
        this.$router.push({ name: sectionName }).catch(() => { });
    }

    public toggleAccordion(sectionName: string) {
        document.getElementById(sectionName).classList.toggle("selected");
    }
}